import React from 'react';
import { Box, Image, ResponsiveContext, Text } from "grommet"
import logo from '../../../images/logo.png';
import StepProgress from '../../elements/steps_progress';
import { STEP } from '../../../services/types';
import { getFirstPayAmount } from '../../../services/services';
import { isSmallDevis, toCurrency } from '../../../services/utils';
import translate from '../../../i18n/translate';
import LanguageSelector from '../language_selector';
import { withTrans } from '../../../i18n/withTrans';
import ResponsiveHeader from '../../responsive/header';

const MHHeader = ({ devis, onNext, onPrev, stepPosition = 10, step, checkout, language, onLangChange, submitable = true, saveDevis }) => {
    let leftHidden = step === STEP.presentation || step === STEP.payment;
    let rightHidden = step === STEP.payment;
    let rightLable = step === STEP.recap ? `${translate('massure_pour')} ${toCurrency(getFirstPayAmount(devis))}` : translate('suivant')

    const _onNext = () => {
        if (step === STEP.recap) {
            saveDevis();
            checkout();
            return;
        }
        onNext();
    }

    return (
        <ResponsiveContext.Consumer>
            {size => (
                isSmallDevis(size) ?
                    <ResponsiveHeader
                        devis={devis}
                        onPrev={onPrev}
                        onNext={onNext}
                        stepPosition={stepPosition}
                        step={step}
                        checkout={checkout}
                        language={language}
                        onLangChange={onLangChange}
                        submitable={submitable}
                        size={size}
                        saveDevis={saveDevis}
                    /> :
                    <Box align='center' justify='center' gap='small' width={'full'}

                    >
                        <Box justify='center' width={'medium'} pad={'small'} align='center'>
                            <Image src={logo} />

                            <Box style={{ position: 'absolute', right: 200 }}>
                                <LanguageSelector
                                    onLangChange={onLangChange}
                                    language={language}
                                />
                            </Box>
                        </Box>
                        <Box
                            direction="row"
                            alignContent="between"
                            justify='center'
                            style={{ backgroundColor: "#E6E6E6", height: 80, width: '100%' }}
                        >
                            <Box alignContent="center" justify="between" style={{ width: '100%' }} align='center' direction='row'>
                                {!leftHidden && submitable ?
                                    <Box width={'small'} style={{ background: '#59A4F4', height: 80 }} justify='center'
                                        onClick={onPrev}
                                    >
                                        <Text textAlign='center' color={'#fff'} style={{ fontWeight: 'bold' }}>{translate('retour')}</Text>
                                    </Box> :
                                    <Box style={{ width: 300 }} />
                                }
                                <Box width={'large'}>
                                    <StepProgress value={stepPosition} submitable={submitable} />
                                </Box>
                                {(rightHidden || !submitable) ?
                                    <Box style={{ width: 300 }} /> :
                                    <Box width={'small'} style={{ background: '#E92C70', height: 80 }} justify='center'
                                        onClick={_onNext}
                                    >
                                        <Text textAlign='center' color={'#fff'} style={{ fontWeight: 'bold' }}>{rightLable}</Text>
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
            )}
        </ResponsiveContext.Consumer>
    )
}

export default MHHeader;